import React from 'react';
import { Button, Flex, Stack } from '@grubhubprod/gh-cookbook-react';
import { useForm, FormProvider } from 'react-hook-form/dist/index.ie11';
import { ChildAccountNameInputText } from 'src/components/enterprise/Parents/Children/ParentChildAccountController/ChildAccountNameInputText/ChildAccountNameInputText';

export interface IChildAccountEditProps {
  childAccountName: string;
  uniqueDisplayKey: string;
  onClickUpdate: (childAccountName: string, uniqueDisplayKey: string) => void;
  onCancelEdit: () => void;
}

export function ChildAccountEdit({
  childAccountName,
  uniqueDisplayKey,
  onClickUpdate,
  onCancelEdit,
}: IChildAccountEditProps): JSX.Element {
  const useFormProps = useForm<IChildAccountEditProps>({
    defaultValues: {
      childAccountName,
    },
    mode: 'onSubmit',
  });

  const { handleSubmit, formState } = useFormProps;
  const { isDirty } = formState;

  async function onNameSubmit({ childAccountName }) {
    onClickUpdate(childAccountName, uniqueDisplayKey);
  }

  return (
    <FormProvider {...useFormProps}>
      <Flex alignItems="center">
        <Stack x="x-sm">
          <ChildAccountNameInputText
            name="childAccountName"
            id="childAccountName"
          />
        </Stack>
        <Stack x="x-sm">
          <Button
            variant="primary"
            buttonSize="medium"
            onClick={handleSubmit(onNameSubmit)}
            disabled={!isDirty}
          >
            Update
          </Button>
        </Stack>
        <Stack x="x-sm">
          <Button variant="tertiary" buttonSize="medium" onClick={onCancelEdit}>
            Cancel
          </Button>
        </Stack>
      </Flex>
    </FormProvider>
  );
}
